import React, { Component } from "react";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/styles";
import { I18n } from "@aws-amplify/core";
import { fetchGet } from "../../api/fetch";
import Grid from "@material-ui/core/Grid";
import colors from "../../assets/style/colors";
import { API_DATASTORE } from "../../constants/api";
import Table from "@material-ui/core/Table";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableBody from "@material-ui/core/TableBody";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import CustomButton from "../Common/CustomButton";
import images from "../../assets/img/images";

const styles = {
  container: {
    boxShadow: "0px 0px 4px 0px " + colors.black23,
    borderRadius: "4px",
    backgroundColor: colors.white,
    margin: "0px",
    minHeight: "250px",
    height: "calc(100% - 58px)"
  },
  table: {
    minWidth: 450,
    overflow: "auto"
  },
  tableHeader: {
    cursor: "pointer",
    "&:hover": {
      textDecoration: "underline"
    }
  },
  headerCell: {
    verticalAlign: "top",
    borderBottomColor: colors.black87,
    borderBottomWidth: "2dp",
    fontSize: "0.875em",
    textAlign: "center"
  },
  tableCell: {
    color: colors.black54,
    fontSize: "0.875em",
    height: "45px",
    textAlign: "center"
  },
  containerNew: {
    margin: "18px 18px"
  },
  containerTable: {
    margin: "18px 37px"
  }
};

const fields = [
  {
    name: "name"
  },
  {
    name: "description"
  },
  {
    name: "provider"
  },
  {
    name: "collection"
  }
];

function createData(
  id,
  name,
  description,
  provider,
  collection,
  frconfigurations
) {
  return { id, name, description, provider, collection, frconfigurations };
}

class FRDefinition extends Component {
  constructor(props) {
    super(props);
    this.state = {
      rows: [],
      editMode: false
    };
  }

  async componentDidMount() {
    console.log("componentDidMount");

    // Get sys keys from data store
    let data = await this.getFrDefinition();
    console.log(data);
    let rows = [];
    for (let i = 0; i < data.length; i += 1) {
      rows.push(
        createData(
          data[i].id,
          data[i].name,
          data[i].description,
          data[i].provider_name,
          data[i].parameters[0].collectionname,
          data[i].frconfigurations
        )
      );
    }
    console.log(rows);
    this.setState({ rows: rows });
  }

  componentWillUnmount() {
    console.log("componentWillUnmount");
  }

  componentDidUpdate() {
    console.log("componentDidUpdate");
  }

  getFrDefinition = async () => {
    try {
      let res = await fetchGet("ds/sys/cfg.fr.definitions", API_DATASTORE);
      if (res.data && res.data.length > 0) {
        return res.data;
      }
    } catch (e) {
      console.log(e);
      return [];
    }
  };

  renderHeader = field => {
    return (
      <TableCell
        align="center"
        key={field}
        className={this.props.classes.headerCell}
      >
        <span className={this.props.classes.tableHeader + " text-87"}>
          {I18n.get("frdefinition_" + field)}
        </span>
      </TableCell>
    );
  };

  render() {
    const { classes } = this.props;

    return (
      <Grid
        container
        direction="column"
        wrap="nowrap"
        className={classes.container}
      >
        <Grid item className={classes.containerNew}>
          <CustomButton
            variant="contained"
            color="primary"
            disabled={this.state.editMode}
            startIcon={
              <img
                src={
                  this.state.editMode
                    ? images.plusIconDarkGrey
                    : images.plusIconWhite
                }
                alt="plus"
              />
            }
            onClick={() => this.setState({ editMode: true })}
          >
            {I18n.get("common_new")}
          </CustomButton>
        </Grid>
        <Grid item className={classes.containerTable}>
          <TableContainer>
            <Table className={classes.table} aria-label="simple table">
              <TableHead>
                <TableRow>
                  {fields.map(f => this.renderHeader(f.name))}
                  <TableCell
                    className={this.props.classes.headerCell}
                  ></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {this.state.rows.map(row => (
                  <TableRow key={row.id}>
                    <TableCell
                      component="th"
                      scope="row"
                      className={classes.tableCell}
                    >
                      {row.name}
                    </TableCell>
                    <TableCell className={classes.tableCell}>
                      {row.description}
                    </TableCell>
                    <TableCell className={classes.tableCell}>
                      {row.provider}
                    </TableCell>
                    <TableCell className={classes.tableCell}>
                      {row.collection}
                    </TableCell>
                    <TableCell>
                      <img
                        src={images.iconCopy}
                        alt=""
                        style={{ paddingLeft: "25px", paddingBottom: "1px" }}
                      />
                      <img
                        src={images.iconEdit}
                        alt=""
                        style={{ paddingLeft: "25px", paddingBottom: "1px" }}
                      />
                      <img
                        src={
                          row.frconfigurations.length === 0
                            ? images.iconDelete
                            : images.iconDeleteGray
                        }
                        alt="used"
                        style={{ paddingLeft: "25px", paddingBottom: "1px" }}
                      />
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
      </Grid>
    );
  }
}

const mapStateToProps = state => {
  return {
    language: state.user.language
  };
};

export default connect(mapStateToProps)(withStyles(styles)(FRDefinition));
